import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CheckCircle2Icon, XIcon } from "lucide-react";
import { BUYER_NAMES, SPAIN_CITIES } from "../lib/data";
function randomOf<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
interface Notice {
  id: number;
  name: string;
  city: string;
  mins: number;
}
export function PurchasePopup() {
  const [notice, setNotice] = useState<Notice | null>(null);
  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;
    let hideId: ReturnType<typeof setTimeout>;
    let counter = 0;
    const show = () => {
      counter += 1;
      setNotice({
        id: counter,
        name: randomOf(BUYER_NAMES),
        city: randomOf(SPAIN_CITIES),
        mins: Math.floor(Math.random() * 12) + 1
      });
      hideId = setTimeout(() => setNotice(null), 5000);
      timeoutId = setTimeout(show, Math.floor(Math.random() * 8000) + 9000);
    };
    timeoutId = setTimeout(show, 4000);
    return () => {
      clearTimeout(timeoutId);
      clearTimeout(hideId);
    };
  }, []);
  return <div className="pointer-events-none fixed inset-x-0 bottom-24 z-40 flex justify-center px-4" data-id="element-153" data-mp="115ut04qhlwps">
      <AnimatePresence data-id="element-154" data-mp="1fur4kbrr5rv5">
        {notice && <motion.div key={notice.id} initial={{
        opacity: 0,
        y: 24,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 24,
        scale: 0.95
      }} transition={{
        duration: 0.3,
        ease: "easeOut"
      }} className="pointer-events-auto flex w-full max-w-sm items-center gap-3 rounded-2xl border border-slate-200 bg-white p-3 shadow-xl" data-id="element-155" data-mp="1fxmzdr8b00fd">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-teal-100" data-id="element-156" data-mp="s5ojetxwtgvw">
              <CheckCircle2Icon className="h-6 w-6 text-teal-600" data-id="element-157" data-mp="28jojc4wr96j5" />
            </div>
            <div className="min-w-0 flex-1" data-id="element-158" data-mp="23lwg4eqntxzn">
              <p className="text-sm font-bold leading-tight text-slate-800" data-id="element-159" data-mp="23l3ic39oiitn">
                {notice.name} compró el Megapack
              </p>
              <p className="truncate text-xs text-slate-500" data-id="element-160" data-mp="2fneb3lzi12tx">
                desde {notice.city} · hace {notice.mins} min
              </p>
            </div>
            <button type="button" onClick={() => setNotice(null)} aria-label="Cerrar aviso" className="shrink-0 rounded-full p-1 text-slate-300 hover:text-slate-500" data-id="element-161" data-mp="2kniq17krdpi1">
              <XIcon className="h-4 w-4" data-id="element-162" data-mp="1wwwuugvurzpg" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}